import axios from 'axios'
import {AuthModel, UserModel} from './_models'

const API_URL = process.env.REACT_APP_API_URL

export const GET_USER_BY_ACCESS_TOKEN_URL = `${API_URL}/api/verify_token`
export const LOGIN_URL = `${API_URL}/api/login`
export const REGISTER_URL = `${API_URL}/api/register`
export const REQUEST_PASSWORD_URL = `${API_URL}/api/forgot_password`

// Server should return AuthModel
export function login(username: string, password: string) {
  return axios.post<AuthModel>(LOGIN_URL, {
    username,
    password,
  })
}

export function getUserByToken(token: string) {
  return axios.post<UserModel>(GET_USER_BY_ACCESS_TOKEN_URL, {
    api_token: token,
  })
}
